import React, {useEffect, useState, Fragment, useContext} from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import {BaseUrl} from 'contexts/baseUrl/baseUrl';
import {Link} from 'react-router-dom';

const ViewHelper = ({
                        match,
                        listing = null,
                        list = [],
                    }) => {
    const headers = [
        'Helper Name',
        'Helper Designation',
        'Mobile Number',
        'Email Address',
        'Status',
        'Actions',
    ];
    const [listData, setListData] = useState();
    const {baseUrl} = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);

    const headerBtns = () => {
        return (
            <Fragment>
                <Link
                    to={`${baseUrl}/brand-activation/add-helper/${match?.params?.lead_id}/${match?.params?.id}`}
                    className="btn btn-primary d-md-inline-block"
                >
                    Add Helper
                </Link>
            </Fragment>
        );
    };

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await listing(match?.params?.lead_id);
            setIsLoading(false);
        })();

    }, []);

    useEffect(() => {
        const tableData = ['id', 'name', 'designation', 'phone_no', 'email'];
        if (list.data) {
            const data = list?.data.map((element) =>
                Object.assign(
                    {},
                    ...tableData.map((key) => ({[key]: element[key]})),
                    {
                        Status: parseInt(element.status) === 1 ? "Active" : "Inactive",
                        Actions: {
                            name: 'Edit Details',
                            link: `${baseUrl}/brand-activation/edit-helper/${match?.params?.lead_id}/${match?.params?.id}/${element['id']}`,
                            from: 'pocList',
                        },
                    }
                )
            );
            data && setListData(data);
            setPageCount(Math.ceil(list.total / list.per_page));
        }
    }, [list]);

    const onPageChange = async (val) => {
        setIsLoading(true);
        await listing(match?.params?.lead_id, val.selected + 1);
        setIsLoading(false);
    };

    return (
        <Layout
            title={localization.viewHelpers}
            Buttons={headerBtns}
            isGoback
            isLoading={isLoading}
            linkUrl={`${baseUrl}/ba-business-list`}
        >
            <TableSection
                data={listData}
                isId={false}
                headers={headers}
                pageCount={pageCount}
                onPageChange={onPageChange}
                srNo={list?.from}
            />
        </Layout>
    );
};

export default ViewHelper;
